import { useParams } from 'react-router-dom'
import client from './client'
import { ApplicationShareInfo } from '@/types'

export const getShareInfoList = () => {
  return client<{ detail: ApplicationShareInfo[] }>({
    method: 'GET',
    url: 'promotions',
  })
}

export const validateShareCode = (promotion: string) => {
  return client<{ isvalid: boolean }>({
    method: 'GET',
    url: 'promotion/check',
    params: { promotion },
  })
}

export const subscribeAutomation = (params: { promotion: string; org_id: number }) => {
  return client<{ url: string }>({
    method: 'POST',
    url: 'promotion/auto-open',
    data: params,
  })
}

export const addShareLinkClickCount = (promotion: string) => {
  return client<unknown>({
    method: 'POST',
    url: 'promotion/add-hit',
    data: { promotion },
  })
}

/**
 * 调整比例
 * @param data
 * @returns
 */
export const postPromotionAdjustPercentage = (data: { ambassador_percentage: number }) => {
  return client<unknown>({
    method: 'POST',
    url: 'promotion_ambassador/adjust_percentage',
    data,
  })
}

// 查看推广大使条件
export const getPromotionCheck = () => {
  return client<any>({
    method: 'GET',
    url: 'promotion_ambassador/check',
  })
}

export const getPromotionInfo = () => {
  return client<any>({
    method: 'GET',
    url: 'promotion_ambassador/info',
  })
}

export const postPromotionJoin = () => {
  return client<unknown>({
    method: 'POST',
    url: 'promotion_ambassador/join',
  })
}

export const getPromotionOrders = (params: { page: number; size: number }) => {
  return client<any>({
    method: 'GET',
    url: 'promotion_ambassador/orders',
    params,
  })
}

export const getPromotionStatistics = (params: { page: number; size: number }) => {
  return client<any>({
    method: 'GET',
    url: 'promotion_ambassador/statistics',
    params,
  })
}

export const postPromotionWithdrawal = (data: {
  amount: string
  card_holder: string
  card_number: string
  id_card: string
  bank: string
  phone: string
}) => {
  return client<any>({
    method: 'POST',
    url: 'promotion_ambassador/withdrawal',
    data,
  })
}

export const getPromotionWithdrawalRecords = (params: { page: number; size: number }) => {
  return client<any>({
    method: 'GET',
    url: 'promotion_ambassador/withdrawal_records',
    params,
  })
}

export const getPromotionInvitedUsers = (params: { page: number; size: number }) => {
  return client<any>({
    method: 'GET',
    url: 'promotion_ambassador/invited_users',
    params,
  })
}

export const postPromotionCardUpload = (data: { file: File }) => {
  return client<{ url: string }>({
    url: 'promotion_ambassador/upload_id_card',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
